import { render, staticRenderFns } from "./sendMessageDetail.vue?vue&type=template&id=3389712a"
import script from "./sendMessageDetail.vue?vue&type=script&lang=js"
export * from "./sendMessageDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports